import { useState, useEffect, useContext } from 'react'
import EnvContext from '../context/EnvContext'

import { gql, useQuery } from '@apollo/client';

const USER_QUERY = gql`
query ($title: String!) {
  puser(where: {titlebar: {_eq: $title}}) {
    email
    firstName
    lastName
    personId
  }
}
`

const USER_QUERY_SELECTIVE = gql`
query ($_in: [bigint!]!, $title: String!) {
  puser(where: {personId: {_in: $_in}, titlebar: {_eq: $title}}) {
    email
    firstName
    lastName
    personId
  }
}
`

export const usePuser = (ids, titlebar) => {
    const envSelected = useContext(EnvContext)
    const [lookupData, setLookupData] = useState({})
    const { data, loading } = useQuery(USER_QUERY_SELECTIVE, {
        variables: {
            "_in": ids,
            "title": titlebar
        }
    })

    useEffect(() => {
        if (!loading && data) {
            setLookupData(data.puser.reduce((acc, d) => {
                if (d)
                    acc[d.personId] = {
                        'id': d.personId,
                        'email': d.email,
                        'first': d.firstName,
                        'last': d.lastName,
                    }
                return acc
            }, {}))
        }
    }, [data, loading, envSelected])

    return lookupData
}

export const usePuserId = (personId, backend) => {

    // This function is used to get the puser ID map from the backend
    // EU and US backend will have different IDs for the same puser
    // Due to the nature of the apollo cache we need to do 2 "different" queries to get this to work
    // Even fetchPolicy: "no-cache" doesnt work. This is a workaround
    // We only need to do this when we query from 2 backends at the same time and expect different results, which is rare

    const USER_QUERY_ID_US = gql`
    query query1($personId: bigint!) {
    puser(where: {personId: {_eq: $personId}, id: {_gte: "-3"}}) {
        id
    }
    }
    `

    const USER_QUERY_ID_EU = gql`
    query query2($personId: bigint!) {
    puser(where: {personId: {_eq: $personId}, id: {_gte: "-2"}}) {
        id
    }
    }
    `

    const envSelected = useContext(EnvContext)
    const [lookupData, setLookupData] = useState(0)
    const { data, loading } = useQuery((backend === 'us' ? USER_QUERY_ID_US : USER_QUERY_ID_EU), {
        variables: {
            "personId": personId
        }, context: { backend: backend }
    })

    useEffect(() => {
        if (!loading && data && data.puser && data.puser.length > 0) {
            setLookupData(data.puser[0].id)
        }
    }, [data, loading, envSelected])

    return lookupData

}


export const useAllPuser = (titlebar) => {
    const [lookupData, setLookupData] = useState({})
    const { data, loading } = useQuery(USER_QUERY, {
        variables: {
            "title": titlebar
        }
    })

    useEffect(() => {
        if (!loading && data) {
            setLookupData(data.puser.reduce((acc, d) => {
                if (d)
                    acc[d.personId] = {
                        'id': d.personId,
                        'email': d.email,
                        'first': d.firstName,
                        'last': d.lastName,
                    }
                return acc
            }, {}))
        }
    }, [data, loading])

    return lookupData
}
